import React, { useEffect } from "react";
import "./SignOutScreen.scss";
import { getConfigValue } from "../../utils/config";
import makeUrl from "../../utils/UrlMaker";

import Text from "../../components/Text";
import LayoutSimple from "../../components/LayoutSimple";

const SignOutScreen = (props) => {
  useEffect(() => {
    !!props.logout && props.logout();

    let redir = new Promise((r) => setTimeout(r, 2000));
    let redirectUri = getConfigValue("url");
    let redirect = "";
    if (!!redirectUri) {
      redirect = `?RedirectUrl=${encodeURIComponent(redirectUri)}`;
    }
    redir.then(() => {
      if (!!getConfigValue("authProviderUrl"))
        window.location.href =
          getConfigValue("authProviderUrl") + `/auth/logout${redirect}`;
      else {
        window.location.href = makeUrl(
          "authServiceUrl",
          `/auth/logout${redirect}`
        );
      }
    });
  });
  return (
    <LayoutSimple>
      <div className="sign-out-screen">
        <Text value="Logged_Out" />
      </div>
    </LayoutSimple>
  );
};

export default SignOutScreen;
